import { resolveApiBaseUrl } from "./runtime-config";

// runtime-config.js is loaded before the application module in index.html.
// A neutral container build cannot fall back to a baked-in API origin.
export const API_BASE_URL = resolveApiBaseUrl(
  typeof window === "undefined" ? undefined : window.__TRIPBEARS_CONFIG__,
  import.meta.env.VITE_RUNTIME_CONFIG === "true",
  import.meta.env.VITE_API_BASE_URL,
);
export const API_V1_URL = `${API_BASE_URL}/v1`;
